import capitalizeFilterLabel from "../utils/capitalizeFilterLabel";

export const CLIENT_PREFERENCES_SORT_OPTIONS = [
  { value: "firstName", label: "Staff First Name" },
  { value: "lastName", label: "Staff Last Name" },
  { value: "type", label: "Type" },
  { value: "rating", label: "Rating" },
  { value: "created", label: "Created" },
];

export const CLIENT_PREFERENCES_TYPE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "do-not-place", label: "Do not place" },
  { value: "needs-improvement", label: "Needs improvement" },
  { value: "neutral", label: "Neutral" },
  { value: "good-fit", label: "Good fit" },
  { value: "like", label: "Like" },
];

export const CLIENT_PREFERENCES_DEFAULT_FILTERS = {
  filterType: "all",
  showDeleted: false,
  sortBy: "firstName",
  sortDirection: "asc",
};

export function buildClientPreferencesFilterChips({ filterType, showDeleted }) {
  const chips = [];
  if (filterType && filterType !== "all") {
    const label =
      CLIENT_PREFERENCES_TYPE_OPTIONS.find((o) => o.value === filterType)?.label ||
      capitalizeFilterLabel(filterType);
    chips.push({
      id: "type",
      key: "filterType",
      fieldId: "preferences-type",
      label: `Type: ${label}`,
    });
  }
  if (showDeleted) {
    chips.push({
      id: "deleted",
      key: "showDeleted",
      fieldId: "preferences-show-deleted",
      label: "Show Deleted",
    });
  }
  return chips;
}
